/* eslint-disable max-lines */
import { PlusOutlined } from '@ant-design/icons';
import { Form, Input, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SearchPanel } from 'src/components/SearchPanel/SearchPanel';
import {
    SearchPanelFilterForm,
    SearchPanelFilterFormProps,
} from 'src/components/SearchPanel/SearchPanelFilterForm';
import { Env } from 'src/core/Environment';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Router } from 'src/core/router/Router';
import { LeadsFilter, LeadsStore } from 'src/stores/LeadsStore/LeadsStore';
import { UserStore } from 'src/stores/UserStore/UserStore';
import { CssColors } from 'src/styles/CssVariables';
import styled from 'styled-components';

const store = LeadsStore;

export const LeadsPageHeaderPanel = observer(() => {
    const { t } = useTranslation();

    return (
        <StyledHeaderWrapper>
            {Env.appName === 'bo-portal' ? (
                <SearchPanel
                    store={store}
                    placeholder={t('Page.Leads.Filter.Search.Placeholder')}
                    renderPanel={(props) => <FilterPanel {...props} />}
                />
            ) : (
                <SearchPanel
                    store={store}
                    placeholder={t('Page.Leads.Filter.Search.Placeholder')}
                />
            )}
            {UserStore.can.manage.leads && (
                <Tooltip
                    title={t('Page.Leads.AsideHeader.CreateNewItem.Tooltip', {
                        defaultValue: 'Add new lead',
                    })}
                >
                    <StyledCreateButton
                        onClick={() => {
                            const createLink = EntityLinks.leads.create?.();
                            createLink && Router.navigate(createLink);
                        }}
                    >
                        <PlusOutlined />
                    </StyledCreateButton>
                </Tooltip>
            )}
        </StyledHeaderWrapper>
    );
});

const FilterPanel = observer((props: SearchPanelFilterFormProps) => {
    const { t } = useTranslation();

    return (
        <SearchPanelFilterForm
            {...props}
            onFinish={({ ...values }: LeadsFilter) => {
                store.filterCriteria?.applyFilter({
                    ...values,
                });
                store.loadList();
            }}
        >
            <Form.Item
                label={t('Page.Leads.Filter.Legal.Name')}
                name="legalName"
            >
                <StyledInput />
            </Form.Item>
        </SearchPanelFilterForm>
    );
});

const StyledInput = styled(Input)`
    height: 2.7rem;
    border-radius: 0.5rem;
`;

const StyledHeaderWrapper = styled.header`
    position: relative;
    display: grid;
    grid-template-columns: 1fr auto;
`;

const StyledCreateButton = styled.button`
    width: 3.6rem;
    min-width: 3rem;
    font-weight: 700;
    height: 2.4rem;
    margin-left: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    height: 2rem;
    border: none;
    background: ${CssColors.black};
    border-radius: 0.35rem;
    color: #ffffff;
    span: {
        font-size: 1rem;
    }
`;
